import { FC } from 'react';
import { defaultTheme, Provider } from '@adobe/react-spectrum';
import { PickerProps } from './_models';
import PickerComponent from './_component';

const ColorPicker: FC<PickerProps> = (props) => (
  <div className="d-flex flex-column align-items-center">
    <Provider
      theme={defaultTheme}
      colorScheme="light"
      UNSAFE_style={{ backgroundColor: 'transparent' }}
    >
      <PickerComponent {...props} />
    </Provider>
  </div>
);

export default ColorPicker;
